module.exports = __webpack_public_path__ + "static/media/development_aid_by_country_zach_levy.fd634587.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dataisbeautiful/development_aid_by_country_zach_levy.png
// module id = 235
// module chunks = 0